import { createFileRoute } from "@tanstack/react-router"
import { StyleTransferScreenWrapper } from "./-StyleTransferPage"

export const Route = createFileRoute("/tools/style-transfer")({
  component: StyleTransferScreenWrapper,
})
